<template>
  <div>
    <!-- ================= DETALLE CON CARIÑO ================= -->
    <section ref="raiz" class="lluvia-sobres">
      <div class="contenido">
        
        <!-- Mesa de Regalos -->
        <h2 ref="tituloRef" class="titulo">
          <span class="script">Mesa <br></span>
          <span class="serif"><br><br /> &nbsp;&nbsp;de Regalos</span><br /><br />
        </h2>

        <p ref="textoRef" class="texto">
          Tu presencia es el regalo más valioso para mí. ✨  
          Pero si deseas tener un detalle, lo recibiré con mucho cariño. 
        </p>

        <!-- 🔹 Lluvia de Sobres y ss.png agregado justo arriba de Regalo Físico -->
        <h2 class="titulo">
          <span class="script">Lluvia de <br></span>
          <span class="serif"><br><br /> &nbsp;&nbsp;Sobres</span><br /><br />
        </h2>
        
        <img :src="ssPng" class="imagen-ss"  alt="Lluvia de sobres" /><br /><br />

        <div class="separador-bonito-blanco" aria-hidden="true">
          <span class="rombo-central">✦</span>
        </div>

        <!-- Regalo Físico -->
        <h2 class="titulo">
          <span class="serif">Regalo</span><br />
          <span class="script">Físico</span>
        </h2>

        <!-- 🔹 SOBRE -->
        <img ref="sobreRef" :src="sobrePng" class="icono-sobre" alt="Sobre" />

        <!-- 🔹 TEXTO LLUVIA -->
        <p ref="lluviaTextoRef" class="lluvia-texto"></p>

        <div class="separador-bonito-blanco" aria-hidden="true">
          <span class="rombo-central">✦</span>
        </div>

        <!-- 🔹 CASH APP -->
        <h2 class="titulo">
          <span class="serif">Cash </span><br />
          <span class="script">App</span>
        </h2>

        <!-- 🔥 CASH APP -->
        <div ref="cashRef" class="cash-container">
          <img src="@/assets/codigo_qr.webp" class="cash-img" alt="Cash App QR" />

          <a 
            href="https://cash.app/$Aylenss11" 
            target="_blank" 
            class="cash-link"
          >
            https://cash.app/$Aylenss11
          </a><br /><br />
        </div>
        
        <p ref="graciasRef" class="gracias">¡GRACIAS!</p>

      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der"></div>
      <div class="rasgado rasgado-inferior"></div>

    </section>

  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/r.png'
import ssPng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {

    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const lluviaTextoRef = ref(null)
    const graciasRef = ref(null)
    const cashRef = ref(null)

    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const tituloNinosRef = ref(null)
    const textoNinosRef = ref(null)
    const graciasNinosRef = ref(null)


    let stInstance = null
    let stInstanceNinos = null

    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: 0, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 1,
            duration: 2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {

          const titulos = raiz.value.querySelectorAll('.titulo')

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // 🔥 PRIMER TÍTULO (Mesa de Regalos)
          tl.from(titulos[0], { opacity: 0, y: 30, duration: 0.6 })
            .from(textoRef.value, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')
            
            // 🔥 SEGUNDO TÍTULO (Lluvia de Sobres)
            .from(titulos[1], { opacity: 0, y: 30, duration: 0.6 }, '-=0.2')
            .from(raiz.value.querySelector('.imagen-ss'), { opacity: 0, y: 20, duration: 0.5 }, '-=0.3')

            // 🔥 TERCER TÍTULO (Regalo Físico)
            .from(titulos[2], { opacity: 0, y: 30, duration: 0.6 }, '-=0.2')
            .from(sobreRef.value, { opacity: 0, scale: 0.7, duration: 0.6 }, '-=0.3')
            .from(lluviaTextoRef.value, { opacity: 0, y: 20 }, '-=0.3')

            // 🔥 CUARTO TÍTULO (Cash App)
            .from(titulos[3], { opacity: 0, y: 30, duration: 0.6 })

            // 🔥 CASH APP
            .from(cashRef.value, {
              opacity: 0,
              y: 40,
              scale: 0.9,
              duration: 0.7,
              ease: "back.out(1.7)"
            })

            // 🔥 GRACIAS AL FINAL
            .from(graciasRef.value, { opacity: 0, y: 20, duration: 0.4 })

          crearLluvia(lluviaDer.value)
          crearLluvia(lluviaIzq.value)
        }
      })

      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          gsap.timeline()
            .from(tituloNinosRef.value, { opacity: 0, y: 30 })
            .from(textoNinosRef.value, { opacity: 0, y: 20 }, '-=0.3')
        }
      })
    })

    onUnmounted(() => {
      if (stInstance) stInstance.kill()
      if (stInstanceNinos) stInstanceNinos.kill()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      lluviaTextoRef,
      graciasRef,
      cashRef,
    
      raizNinos,
      tituloNinosRef,
      textoNinosRef,
      graciasNinosRef,
     
      sobrePng,
      ssPng
    }
  }
}
</script>
<style scoped>
.cash-container{
  margin-top: 20px;
  text-align: center;
}

.cash-img{
  width: 140px;
  margin: 10px auto;
  display: block;
}

.cash-link{
  display: block;
  color: white;
  font-size: 22px !important;
  margin-top: 8px;
  text-decoration: underline;
}.separador-bonito-blanco {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 20px;
  margin: 35px auto;
}

/* Las líneas delgadas blancas con desvanecimiento */
.separador-bonito-blanco::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8) 50%, transparent);
}.rombo-central {
  font-size: 14px;
  color: #ffffff;
  background-color: transparent; 
  padding: 0 10px;
  z-index: 1;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.9);
  font-family: serif;
}
</style>


<style scoped>
.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  overflow: hidden;
  background: linear-gradient(135deg, #cb428ed6 0%, #df86af 100%);
}
.contenido{ position: relative; z-index: 2; }

.titulo{
  margin: 0 0 10px;
  color: #fff;
  
  line-height: 1.05;
}
.titulo .serif{
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: .95;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto -44px;
  opacity: .95;
}

.icono-sobre{
  width: 160px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.12));
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: .08em;
  font-weight: 800;
  margin: 4px 0 0;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}
.lluvia-izq{ left: 0; }
.lluvia-der{ right: 0; }

.sobre-lluvia{
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.10));
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
  .icono-sobre{ width: 96px; }
}
.lluvia-texto{
  font-family: 'padres', serif;
  font-size: 18px;
  color: #ffffff;
  margin-top: 8px;
  letter-spacing: .05em;
  opacity: .95;
}
/* La nueva imagen ss.png */
.imagen-ss {
  width: 120px;        /* Tamaño ideal para la imagen de lluvia de sobres */
  height: auto;
  display: block;
  margin: 15px auto;
  margin-bottom:-40px;
}

</style>
